<template>
    <v-card :class="mt ? `mt-${mt}` : ''">
        <v-card-title> {{ title }} </v-card-title>
        <v-card-text>
            <v-row>
                <v-col v-for="{ label, value, cols } in data" :key="label" :cols="cols ? cols : '6'" class="pt-0">
                    <v-text-field :label="label" :value="value" readonly hide-details />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String },
        data: { type: Array },
        mt: { type: String },
    },
};
</script>

<style></style>
